import { render, staticRenderFns } from "./SubscribePromoBenefits.vue?vue&type=template&id=006cb69a&scoped=true&"
import script from "./SubscribePromoBenefits.vue?vue&type=script&lang=js&"
export * from "./SubscribePromoBenefits.vue?vue&type=script&lang=js&"
import style0 from "./SubscribePromoBenefits.vue?vue&type=style&index=0&id=006cb69a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006cb69a",
  null
  
)

export default component.exports